export default __webpack_public_path__ + "static/media/home_content_2.2c889021.png";